const DOCUMENT_MALWARE_TAG_SCOPE = 'document-malware-tag';

export const DocumentMalwareTagTestIds = {
  getTagId: documentId => `${DOCUMENT_MALWARE_TAG_SCOPE}.tag-${documentId}`,
};
